import { render, staticRenderFns } from "./AggiungiIntervento.vue?vue&type=template&id=6066df1e&"
import script from "./AggiungiIntervento.vue?vue&type=script&lang=js&"
export * from "./AggiungiIntervento.vue?vue&type=script&lang=js&"
import style0 from "./AggiungiIntervento.vue?vue&type=style&index=0&id=6066df1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports